
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip-paper-order)"}},[_c('path',{attrs:{"d":"M19.321 0H4.68a.76.76 0 00-.76.76V23.24a.76.76 0 001.236.593l1.549-1.244 1.197 1.19a.76.76 0 001.055.017l1.268-1.184 1.255 1.181a.76.76 0 001.06-.016l1.129-1.131 1.134 1.132a.76.76 0 001.056.017l1.318-1.231 1.686 1.281a.76.76 0 001.22-.605V.76a.76.76 0 00-.76-.76zM7.853 11.403h5.331a.76.76 0 010 1.52H7.853a.76.76 0 010-1.52zm-.76-2.818c0-.42.34-.76.76-.76h3.286a.76.76 0 110 1.52H7.853a.76.76 0 01-.76-.76zm7.844 7.917H7.853a.76.76 0 010-1.52h7.084a.76.76 0 010 1.52zm.986-10.736h-8.07a.76.76 0 010-1.52h8.07a.76.76 0 010 1.52z","fill":"#838383"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip-paper-order"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    